import { makeStyles } from '@material-ui/core/styles';
import { DIMENSIONS } from '../../styles/constants';

export const useStyles = makeStyles(theme => ({
	tabbar: {
		zIndex: 100,
		width: '100%',
		backgroundColor: theme.palette.common.white,
		minHeight: DIMENSIONS.TABBAR_HEIGHT_XS,
		marginTop: DIMENSIONS.NAVBAR_HEIGHT_XS + 20,
		top: DIMENSIONS.NAVBAR_HEIGHT_XS,
		[`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
			minHeight: DIMENSIONS.TABBAR_HEIGHT_XS,
			top: DIMENSIONS.NAVBAR_HEIGHT_XS
		},
		[theme.breakpoints.up('sm')]: {
			minHeight: DIMENSIONS.TABBAR_HEIGHT,
			top: DIMENSIONS.NAVBAR_HEIGHT
		}
	},
	tabsRoot: {
		minHeight: DIMENSIONS.TABBAR_HEIGHT_XS,
		[theme.breakpoints.up('sm')]: {
			minHeight: DIMENSIONS.TABBAR_HEIGHT
		},
		justifyContent: 'center'
	},
	tabsScroller: {
		flexGrow: '0'
	},
	tabsIndicator: {
		backgroundColor: theme.palette.primary.main
	},
	tabRoot: {
		width: 190,
		maxWidth: 210,
		minHeight: DIMENSIONS.TABBAR_HEIGHT_XS,
		[theme.breakpoints.only('md')]: {
			width: 150,
			maxWidth: 170
		},
		[theme.breakpoints.down('sm')]: {
			width: 140,
			maxWidth: 160
		},
		[theme.breakpoints.up('sm')]: {
			minHeight: DIMENSIONS.TABBAR_HEIGHT
		},
		marginRight: theme.spacing(2),
		'&:hover': {
			color: theme.palette.secondary.main,
			opacity: 1
		},
		'&$tabSelected': {
			color: theme.palette.secondary.main,
			fontWeight: theme.typography.fontWeightMedium
		},
		'&:focus': {
			color: theme.palette.secondary.main,
			backgroundColor: ''
		},
		'&:disabled': {
			color: 'rgb(85, 85, 85)'
		}
	},
	tabSelected: {},
	tabIcon: {
		margin: '0px 7px -7px 0px',
		[theme.breakpoints.down('xs')]: {
			fontSize: '1.25rem',
			margin: '0px 5px -5px 0px'
		}
	},
	tabLabelContainer: {
		display: 'inline-block'
	}
}));

export const useLinearProgressStyles = makeStyles(theme => ({
	root: {
		position: 'absolute',
		top: 0,
		width: '100%',
		zIndex: theme.zIndex.appBar + 1
	}
}));
